import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { EmptyState } from '@steelbuy/ui-primitive';
import { RoutePath } from '../../router/Routes';

export const MyListingEmptyState = ({ navigateTo }: { navigateTo?: string }) => {
    const { t } = useTranslation(['translation', 'uiDomain']);
    const navigate = useNavigate();

    return (
        <div className="my-listings-drafts__empty-state-container">
            <EmptyState
                caption={t('uiDomain:commonList.noListCaption')}
                description={t('application.myListings.noResultsDescription')}
                button={{
                    label: t('application.myListings.noListingsCallToAction'),
                    onClick: () => navigate(navigateTo ?? RoutePath.CREATE_LISTING_WIZARD),
                }}
            />
        </div>
    );
};
